import type {
  AccessAlertPage,
  FdsAction,
  FdsCaseDetail,
  FdsCasePage,
  FdsDecisionRequest,
  FdsDecisionResult,
  FdsQueueView,
} from "@kkp/api-client";
import { apiRequest } from "./client";

export type { FdsAction, FdsQueueView } from "@kkp/api-client";

export function listFdsCases(
  view: FdsQueueView,
  limit: number,
  offset: number,
): Promise<FdsCasePage> {
  return apiRequest<FdsCasePage>({
    path: `/fds/cases?view=${view}&limit=${limit}&offset=${offset}`,
    method: "GET",
  });
}

export function getFdsCase(id: string): Promise<FdsCaseDetail> {
  return apiRequest<FdsCaseDetail>({
    path: `/fds/cases/${id}`,
    method: "GET",
  });
}

export function listAccessAlerts(
  limit: number,
  offset: number,
): Promise<AccessAlertPage> {
  return apiRequest<AccessAlertPage>({
    path: `/fds/access-alerts?limit=${limit}&offset=${offset}`,
    method: "GET",
  });
}

export function decideFdsCase(
  id: string,
  action: FdsAction,
  body?: FdsDecisionRequest,
): Promise<FdsDecisionResult> {
  return apiRequest<FdsDecisionResult, FdsDecisionRequest>({
    path: `/fds/cases/${id}/${action}`,
    method: "POST",
    body,
  });
}
